import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  genre: JSON.parse(localStorage.getItem("genre")) || "",
  id: JSON.parse(localStorage.getItem("genreID")) || "",
};

const genreSlice = createSlice({
  name: "genre",
  initialState,
  reducers: {
    setGenre: (state, action) => {
      state.genre = action.payload;
      localStorage.setItem("genre", JSON.stringify(action.payload));
    },
    setGenreID: (state, action) => {
      state.id = action.payload;
      localStorage.setItem("genreID", JSON.stringify(action.payload));
    },
  },
});

export const { setGenre, setGenreID } = genreSlice.actions;
export default genreSlice.reducer;
